import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../_metronic/_partials/controls";
import axios from 'axios';
import { API_END_POINTS } from "../../../constant/config";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useDispatch } from "react-redux";
import { checkEmailExists, checkUsernameExists } from "../../../actions/merchants/merchants";

export function PortalMerchantEditAddForm({ merchants, id, btnRef, saveMerchantInfo }) {

  const [isLoading, setIsLoading] = useState(false);

  const [validation, setValidation] = useState(false);

  const dispatch = useDispatch();

  const Schema = Yup.object().shape({
    firstname: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("First Name is required"),
    lastname: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("Last Name is required"),
    username: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("Username is required")
      .test("username", "Username is already exists", async function (username) {
        return await checkAvailabilityUsername(username);
      }),
    email: Yup.string()
      .email("Enter a valid email address")
      .min(5, "Minimum 5 characters")
      .required("Email is required")
      .test("email", "Email already exists in our system", async function (email) {
        return await checkAvailabilityEmail(email);
      }),
    password: Yup.string()
      .min(5, "Minimum 5 characters")
      .required("Password is required"),
    rpassword: Yup.string()
      .min(5, "Minimum 5 characters")
      .required("Confirm Password is required")
      .oneOf([Yup.ref('password')], 'Password and Confirm Password does not match')
  });

  const UpdateSchema = Yup.object().shape({
    firstname: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("First Name is required"),
    lastname: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("Last Name is required"),
    username: Yup.string()
      .min(3, "Minimum 3 characters")
      .required("Username is required"),
    email: Yup.string()
      .email("Enter a valid email address")
      .min(5, "Minimum 5 characters")
      .required("Email is required"),
    password: Yup.string()
      .min(5, "Minimum 5 characters")
      .required("Password is required"),
    rpassword: Yup.string()
      .min(5, "Minimum 5 characters")
      .required("Confirm Password is required")
      .oneOf([Yup.ref('password')], 'Password and Confirm Password does not match')
  });

  const [searchTimeout, setSearchTimeout] = useState(null);

  const checkAvailabilityUsername = (username) => {
    if(username && username !== undefined) {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      return new Promise((resolve, reject) => {
        setSearchTimeout(
          setTimeout(() => {
            dispatch(checkUsernameExists(username)).then(async (data) => {
              if (data.payload.data == 0) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          }, 1000)
        );
        return () => clearTimeout(searchTimeout);
      })
    }
  }

  const checkAvailabilityEmail = (email) => {
    if(email && email !== undefined){
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      return new Promise((resolve, reject) => {
        setSearchTimeout(
          setTimeout(() => {
            dispatch(checkEmailExists(email)).then(async (data) => {
              if (data.payload.data == 0) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          }, 1000)
        );
        return () => clearTimeout(searchTimeout);
      })
    }
  }

  const [merchantStatus, setmerchantStatus] = useState({
    status: 'yes'
  });

  useEffect(() => {
    if (merchants && merchants.id) {

      setmerchantStatus((prevState) => {
        const newState = { ...prevState };
        for (const inputName in newState) {
          newState[inputName] = merchants[inputName];
        }
        return newState;
      });

      // assign password to rpassword value
      merchants['password'] = merchants['rpassword'];

    }
  }, [merchants]);

  const handleStatus = (e, setFieldValue) => {
    let elementName = e.target.name;

    setmerchantStatus((prevState) => {
      const newState = { ...prevState };
      newState[elementName] = prevState[elementName] === 'yes' ? 'no' : 'yes';
      setFieldValue(elementName, prevState[elementName] === 'yes' ? 'no' : 'yes')
      return newState;
    });
  }

  return (
    <>
      {isLoading && <GlobalLoader />}
      <Formik
        enableReinitialize={true}
        initialValues={merchants}
        validationSchema={id ? UpdateSchema : Schema}
        validateOnChange={false}
        onSubmit={async (values, { setErrors }) => {
          await saveMerchantInfo(values);
        }}
      >
        {({ handleSubmit, field, setFieldValue, values, handleChange, errors, handleBlur, setValues }) => (
          <>
            <Form className='form form-label-right'>
              <>
                <div className='form-group row mt-5'>
                  <Field
                    name="firstname"
                    component={Input}
                    placeholder='First Name'
                    label="First Name"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <Field
                    name="lastname"
                    component={Input}
                    placeholder='Last Name'
                    label="Last Name"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <Field
                    name="username"
                    component={Input}
                    placeholder='Username'
                    label="Username"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <Field
                    name="email"
                    component={Input}
                    placeholder='Email'
                    label="Email"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <Field
                    name="password"
                    component={Input}
                    placeholder='Password'
                    label="Password"
                    type="password"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <Field
                    name="rpassword"
                    component={Input}
                    placeholder='Confirm Password'
                    label="Confirm Password"
                    type="password"
                    valid="true"
                  />
                </div>

                <div className='form-group row mt-5'>
                  <label className="col-xl-3 col-lg-2 col-form-label text-right">Status</label>
                  <div className="col-lg-6 col-xl-6">
                    <span className="switch switch-primary switch-md mt-1">
                      <label>
                        <input
                          type="checkbox"
                          name="status"
                          onChange={(e) => {
                            handleStatus(e, setFieldValue)
                          }}
                          checked={merchantStatus["status"] === 'yes'}
                          readOnly
                        />
                        <span></span>
                      </label>
                    </span>
                  </div>
                </div>
              </>
              <button
                type='submit'
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}>
              </button>

            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
